import {FC} from 'react';
import {Navigate} from 'react-router';

import {useAuth} from '@/providers/components/authProvider';

import WholesalePositionsForm from './components/wholesale-position/wholesalePositionsForm';
import CreateWholesalePositionsProvider from './providers/createWholesalePositionsProvider';

/**
 * Create wholesale positions page
 * @returns {JSX.Element}
 */
const CreateWholesalePositionsPage: FC = () => {
  const {isAdmin} = useAuth();

  if (!isAdmin) {
    return <Navigate to="/admin/positions" />;
  }

  return (
    <CreateWholesalePositionsProvider>
      <WholesalePositionsForm />
    </CreateWholesalePositionsProvider>
  );
};

export default CreateWholesalePositionsPage;
